import { useEffect } from "react";
import DialogShell from "./DialogShell";

export default function SuccessDialog({ open, message, onClose, duration = 4000 }) {
  useEffect(() => {
    if (!open || !duration) return undefined;

    const timeout = window.setTimeout(() => onClose?.(), duration);
    return () => window.clearTimeout(timeout);
  }, [duration, onClose, open]);

  if (!open) return null;

  return (
    <DialogShell
      className="admin-dialog--notice admin-dialog--success"
      backdropClassName="admin-dialog-backdrop--toast"
      role="status"
      labelledBy="admin-success-title"
      onClose={onClose}
      modal={false}
      lockScroll={false}
    >
      <button type="button" className="admin-dialog__close" aria-label="Fechar" onClick={onClose}>&times;</button>
      <h2 id="admin-success-title" className="admin-dialog__notice-title">{message || "Alterações salvas com sucesso!"}</h2>
    </DialogShell>
  );
}
